import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";

export default function StaticPage({ title, overline, body, seo }) {
  return (
    <main data-testid={`static-${overline.toLowerCase()}`}>
      {seo && <SEO {...seo} />}
      <PageHeader overline={overline} title={title} />
      <section className="max-w-[780px] mx-auto px-6 lg:px-10 pb-24">
        <div className="text-[15.5px] leading-[1.75] text-[color:var(--text-muted)] whitespace-pre-wrap">{body}</div>
      </section>
    </main>
  );
}
